// src/pages/-[lang]/admin/tools/elastic.tsx
import React, { useContext } from 'react';
import AdminLayout from '@app/layout/AdminLayout.tsx';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Button } from 'primereact/button';
import { ApiContext } from '@api/api';
import { RingilHeading } from '@components/styles.tsx';

interface ComponentProps {
}

const ElasticPage: React.FC<ComponentProps> = () => {
  const { reindexAllSn } = useContext(ApiContext);

  return (
    <AdminLayout title={'Elastic'}>
      <div className="flex flex-col gap-4">
        <RingilHeading>Elastic</RingilHeading>

        <div className="flex flex-col gap-4">
          <div>
            <h3 className="text-lg font-medium mb-2">Elasticsearch</h3>
            <div className="flex flex-col gap-2">
              <Button
                label="Reindex všech Supplier Notifications"
                onClick={() => reindexAllSn(false, () => {}, undefined)}
              />
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default withAuthenticationRequired(ElasticPage);